module.exports = __webpack_public_path__ + "fonts/DINPro-MediumItalic.a6489cbe.otf";